import {createStore} from "vuex";

const store = createStore({
    state () {
        return {
          language: "pt",
          breadcrumb: []
        }
    },
    mutations: {
        setLanguage(state,lang){
            state.language = lang;
        },
        setBreadcrumb(state,breadcrumb){
            state.breadcrumb = breadcrumb;
        }
    }
});

export default store;